import React, { useEffect } from 'react';
import ParticlesBg from 'particles-bg';
import AOS from 'aos';
import 'aos/dist/aos.css';

export const Docheader = (props) => {
  useEffect(() => {
    AOS.init({
      duration: 1000, 
  
    });
  }, []);

  return (
    <header >
      <div style={{ backgroundColor: '#2C5CDF' }} className='intro' data-aos='fade-up'>
        <ParticlesBg
          type='lines'
       
        
          bg={{ zIndex: 0, position: 'absolute', top: 0 }}
        />
        <div className='overlay'>
          <div className='container'>
            <div className='row'>
              <div
                className='col-md-8 col-md-offset-2 intro-text'
                data-aos='fade-up'
                data-aos-delay='300'
              >
                <h2 style={{color:"white"}} >GyanBuddy KMS</h2>
                <div>
                  <h4 style={{ color: 'white' }}>Reimagine Knowledge Management with AI
</h4>
                  <p>Empowering your organization with a centralized hub for knowledge, powered by the power of Artificial Intelligence.

</p>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
